import React from 'react'

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <g>
                <mask
                    id="mask0_5569_132762"
                    style={{ maskType: 'alpha' }}
                    width="24"
                    height="24"
                    x="0"
                    y="0"
                    maskUnits="userSpaceOnUse"
                >
                    <path fill="#D9D9D9" d="M0 0H24V24H0z"></path>
                </mask>
                <g mask="url(#mask0_5569_132762)">
                    <path
                        fill="#1C1B1F"
                        d="M10.154 14H7.169a.615.615 0 01-.59-.355.612.612 0 01.054-.681l5.629-8.154a.727.727 0 01.38-.286.732.732 0 01.48.022c.167.062.289.163.365.304a.762.762 0 01.082.463L12.865 11h3.587c.28 0 .478.128.595.383a.625.625 0 01-.095.71l-6.264 7.503a.699.699 0 01-.834.196.701.701 0 01-.423-.748L10.154 14z"
                    ></path>
                </g>
            </g>
        </svg>
    )
}

export default Icon
